export default {
  "reset-password.title": "Passwort zurücksetzen",
  "reset-password.success.message": "Passwort wurde erfolgreich geändert",
  "reset-password.success.description": "Bitte melden Sie sich erneut an",
  "reset-password.new-password": "Neues Passwort",
  "reset-password.new-password-repeat": "Neues Passwort wiederholen",
  "reset-password.required-field":
    "Bitte füllen Sie alle angegebenen Felder aus",
};
